import Chart from "chart.js/auto";

export function initOffersChart(canvas) {
  if (!canvas) return;

  new Chart(canvas, {
    type: "line",
    data: offerTrendChart,
    options: offerTrendOptions,
  });
}

const offerTrendChart = {
  labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],

  datasets: [
    {
      label: "Pending",
      data: [42, 58, 64, 39, 47, 21, 36],

      borderColor: "#f97316",
      backgroundColor: "rgba(249, 115, 22, 0.08)",

      fill: true,

      tension: 0.15,
      borderWidth: 3,

      pointRadius: 4,
      pointHoverRadius: 6,

      pointBackgroundColor: "#ffffff",
      pointBorderColor: "#f97316",
      pointBorderWidth: 2,
    },

    {
      label: "Accepted",
      data: [12, 18, 26, 20, 24, 15, 28],

      borderColor: "#22c55e",
      backgroundColor: "transparent",

      fill: false,

      tension: 0.15,
      borderWidth: 3,

      pointRadius: 4,
      pointHoverRadius: 6,

      pointBackgroundColor: "#ffffff",
      pointBorderColor: "#22c55e",
      pointBorderWidth: 2,
    },

    {
      label: "Countered",
      data: [21, 29, 33, 24, 31, 19, 27],

      borderColor: "#8b5cf6",
      backgroundColor: "transparent",

      fill: false,

      tension: 0.15,
      borderWidth: 3,

      pointRadius: 4,
      pointHoverRadius: 6,

      pointBackgroundColor: "#ffffff",
      pointBorderColor: "#8b5cf6",
      pointBorderWidth: 2,
    },

    {
      label: "Declined",
      data: [8, 11, 14, 9, 12, 7, 10],

      borderColor: "#ef4444",
      backgroundColor: "transparent",

      fill: false,

      tension: 0.15,
      borderWidth: 3,

      pointRadius: 4,
      pointHoverRadius: 6,

      pointBackgroundColor: "#ffffff",
      pointBorderColor: "#ef4444",
      pointBorderWidth: 2,
    },
  ],
};

const offerTrendOptions = {
  responsive: true,
  maintainAspectRatio: false,

  plugins: {
    legend: {
      position: "top",
      align: "start",

      labels: {
        usePointStyle: true,
        pointStyle: "circle",
        boxWidth: 8,
        boxHeight: 8,
        padding: 20,
      },
    },

    tooltip: {
      mode: "index",
      intersect: false,
    },
  },

  interaction: {
    mode: "nearest",
    axis: "x",
    intersect: false,
  },

  scales: {
    x: {
      grid: {
        display: false,
      },

      border: {
        display: false,
      },

      ticks: {
        color: "#64748b",
      },
    },

    y: {
      beginAtZero: true,

      ticks: {
        stepSize: 20,
        color: "#64748b",
      },

      grid: {
        color: "#f1f5f9",
      },

      border: {
        display: false,
      },
    },
  },
};
